export const ASSIGNED_TENDERS_LOAD_DETAILS_DATA = 'ASSIGNED_TENDERS_LOAD_DETAILS_DATA'
export const ASSIGNED_TENDERS_LOAD_DETAILS_DATA_REQUEST = (entId, tenderId) =>
    `ASSIGNED_TENDERS_LOAD_DETAILS_${entId}_${tenderId}_DATA_REQUEST`
export const ASSIGNED_TENDERS_DETAILS_TABLE_LOADING_TRUE = 'ASSIGNED_TENDERS_DETAILS_TABLE_LOADING_TRUE'
export const ASSIGNED_TENDERS_DETAILS_TABLE_LOADING_FALSE = 'ASSIGNED_TENDERS_DETAILS_TABLE_LOADING_FALSE'
export const ASSIGNED_TENDERS_DETAILS_TABLE_LOADING_FAILED = 'ASSIGNED_TENDERS_DETAILS_TABLE_LOADING_FAILED'
export const ASSIGNED_TENDERS_DETAILS_TABLE_DATA_RECEIVED = 'ASSIGNED_TENDERS_DETAILS_TABLE_DATA_RECEIVED'
